import {CSSProperties, useEffect, useState} from "react";
import {THEME} from "@components/core/theme";
import {Localisation} from "@components/localisation/localisation";

const WiktionaryAPI: Record<string, string> = {
    "en-GB": "https://en.wiktionary.org/api/rest_v1/page/definition/{word}"
};
const WiktionaryLink = "https://en.wiktionary.org/";
const WiktionaryLicence =
    "https://en.wiktionary.org/wiki/Wiktionary:Text_of_Creative_Commons_Attribution-ShareAlike_4.0_International_License";
const WiktionaryError = [{
    partOfSpeech: "Noun",
    definitions: [{
        definition: "Not found, as in not listed on wiktionary.",
        sanitised: "Not found, as in not listed on wiktionary."
    }]
}];

const styles: Record<string, CSSProperties> =  {
    attribution: {
        display: "flex",
        fontSize: "small",
        justifyContent: "flex-end",
    },
    content: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0
    },
    definition: {
        marginBottom: 4
    },
    footer: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        justifyContent: "flex-end",
    },
    text: {
        ...THEME.text
    },
    word: {
        ...THEME.text
    },
    wordTypes: {
        flexGrow: 1,
        minHeight: 0,
        overflowY: "auto"
    }
};

interface IWordDefinition {
    definition: string
    sanitised: string
}
interface IWordType {
    partOfSpeech: string,
    definitions: IWordDefinition[]
}

interface IDefinition {
    onVisit?: () => void
    word: string
}

export function Definition({onVisit, word}: IDefinition) {
    const language = "en-GB";
    const [wordTypes, setWordTypes] = useState<IWordType[]>();

    useEffect(() => {
        fetch(WiktionaryAPI[language].replace("{word}", word)).then(async response => {
            const [languageDefinitions] = await Promise.all([response.json()]);
            const sanitiseDefinition = (definition: string) =>
                definition.replace(/<a[^>]+>/g, "")

            setWordTypes(languageDefinitions["en"].map((type: IWordType) => ({
                ...type,
                definitions: type.definitions.map(word => ({
                    ...word,
                    sanitised: sanitiseDefinition(word.definition)
                }))
            })));
        }).catch(() => {
            setWordTypes(WiktionaryError)
        })
    }, []);
    return (
        <div style={styles.content}>
            <h2 style={styles.word}>{word}</h2>
            <div style={styles.wordTypes}>
                {wordTypes?.map((type, index) =>
                    <div key={index} style={styles.definition}>
                        <h3 style={styles.text}>{type.partOfSpeech}:</h3>
                        {type.definitions.map((definition, index) =>
                            <div key={index} dangerouslySetInnerHTML={{__html: definition.sanitised}} style={styles.text}/>
                        )}
                    </div>
                )}
            </div>
            <div style={styles.footer}>
                {onVisit && <div style={THEME.buttons}>
                    <button onClick={onVisit} style={THEME.button}>Visit</button>
                </div>}
                <div style={styles.attribution}>
                    <a href={WiktionaryLink} target="Wiktionary"><span style={styles.text}>Wiktionary</span></a>
                    <a href={WiktionaryLicence} target="Licence"><span style={styles.text}>(CC-BY-SA)</span></a>
                </div>
            </div>
        </div>
    );
}